import { A2matFiltersService } from './a2mat-filters.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { A2matFilters } from './a2mat-filters.component';
import { a2MatFilterDialog } from './filter-dialog/filter-dialog.component';
import { FilterInputComponent } from './filter-input/filter-input.component';
import { FilterListComponent } from './filter-list/filter-list.component';
import { FilterDateComponent } from './filter-date/filter-date.component';
import { TranslateModule } from "@ngx-translate/core";
import { FilterMultiComponent } from './filter-multi/filter-multi.component';



@NgModule({
  providers: [A2matFiltersService],
  declarations: [

    A2matFilters,
    a2MatFilterDialog,
    FilterInputComponent,
    FilterListComponent,
    FilterMultiComponent,
    FilterDateComponent
  ],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatRadioModule,
    MatIconModule,
    MatChipsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    CommonModule,
    TranslateModule
  ],
  exports:[
    A2matFilters,
    a2MatFilterDialog
  ]
})
export class A2matFiltersModule { }
